import React from 'react';
import clsx from 'clsx';
import { EllipsisText } from '@brighterion/br-ui';
import styles from './EllipsisTooltip.css';

type Props = {
    text: string;
    position?: string;
    className?: string;
    defaultCursor?: boolean;
};

const EllipsisTooltip = ({ text, position = 'bottom-start', className, defaultCursor }: Props) => {
    return (
        <EllipsisText
            className={clsx(styles.ellipText, defaultCursor && styles.defaultCursor, className)}
            text={text}
            showArrows={false}
            popoverProps={{
                content: text,
                position,
                showArrow: false,
                showCopy: false,
                popperClassName: styles.ellipsisPopOver
            }}
        />
    );
};

export default React.memo(EllipsisTooltip);
